module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    attrs: {
      "id": "feed-posts-page"
    }
  }, [(Object.keys(_vm.feedPosts || {}).length === 0) ? [(_vm.fetchingStatus === 'fetched') ? _c('div', {
    staticClass: "content-box feed-post"
  }, [_vm._v("This user has made no posts")]) : _c('loader-large')] : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "feed-post-collection"
    }
  }, [(_vm.layout === 'masonry') ? _c('vue-masonry', {
    attrs: {
      "min-width": 450,
      "horizontal-gutter": 40,
      "vertical-gutter": 40
    }
  }, [(_vm.isMember && !_vm.showNewPostForm) ? _c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.showNewPostForm = true
      }
    }
  }, [_vm._v("Submit a New Post")]) : _vm._e(), _vm._v(" "), (_vm.isMember && _vm.showNewPostForm) ? _c('div', {
    staticClass: "feed-post",
    attrs: {
      "id": "feed-add-new"
    }
  }, [_c('h2', [_vm._v("Submit a new Post")]), _vm._v(" "), _c('form', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPostSubject),
      expression: "newPostSubject"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Subject (optional)"
    },
    domProps: {
      "value": (_vm.newPostSubject)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPostSubject = $event.target.value
      }
    }
  }), _vm._v(" "), _c('markdown-editor', {
    attrs: {
      "placeholder": "Post Content"
    },
    model: {
      value: (_vm.newPostContent),
      callback: function($$v) {
        _vm.newPostContent = $$v
      },
      expression: "newPostContent"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.submitNewPost($event)
      }
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('button', {
    staticClass: "button minor",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showNewPostForm = false
      }
    }
  }, [_vm._v("Cancel")])], 1)]) : _vm._e(), _vm._v(" "), (Object.keys(_vm.feedPosts || {}).length > 0) ? _vm._l((_vm.feedPosts), function(feedPost) {
    return _c('feed-status-post', {
      key: feedPost.id,
      attrs: {
        "data": feedPost
      }
    })
  }) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.layout === 'single') ? _c('div', {
    staticClass: "single-column-container"
  }, [(_vm.isMember && !_vm.showNewPostForm) ? _c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.showNewPostForm = true
      }
    }
  }, [_vm._v("Submit a New Post")]) : _vm._e(), _vm._v(" "), (_vm.isMember && _vm.showNewPostForm) ? _c('div', {
    staticClass: "feed-post",
    attrs: {
      "id": "feed-add-new"
    }
  }, [_c('h2', [_vm._v("Submit a new Post")]), _vm._v(" "), _c('form', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPostSubject),
      expression: "newPostSubject"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Subject (optional)"
    },
    domProps: {
      "value": (_vm.newPostSubject)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPostSubject = $event.target.value
      }
    }
  }), _vm._v(" "), _c('markdown-editor', {
    attrs: {
      "placeholder": "Post Content"
    },
    model: {
      value: (_vm.newPostContent),
      callback: function($$v) {
        _vm.newPostContent = $$v
      },
      expression: "newPostContent"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.submitNewPost($event)
      }
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('button', {
    staticClass: "button minor",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showNewPostForm = false
      }
    }
  }, [_vm._v("Cancel")])], 1)]) : _vm._e(), _vm._v(" "), (Object.keys(_vm.feedPosts || {}).length > 0) ? _vm._l((_vm.feedPosts), function(feedPost) {
    return _c('feed-status-post', {
      key: feedPost.id,
      attrs: {
        "data": feedPost
      }
    })
  }) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.layout === 'double') ? _c('div', {
    staticClass: "double-column-container"
  }, [(_vm.isMember && !_vm.showNewPostForm) ? _c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.showNewPostForm = true
      }
    }
  }, [_vm._v("Submit a New Post")]) : _vm._e(), _vm._v(" "), _c('vue-masonry', {
    attrs: {
      "min-width": 500,
      "horizontal-gutter": 40,
      "vertical-gutter": 40
    }
  }, [(_vm.isMember && _vm.showNewPostForm) ? _c('div', {
    staticClass: "feed-post",
    attrs: {
      "id": "feed-add-new"
    }
  }, [_c('h2', [_vm._v("Submit a new Post")]), _vm._v(" "), _c('form', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPostSubject),
      expression: "newPostSubject"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Subject (optional)"
    },
    domProps: {
      "value": (_vm.newPostSubject)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPostSubject = $event.target.value
      }
    }
  }), _vm._v(" "), _c('markdown-editor', {
    attrs: {
      "placeholder": "Post Content"
    },
    model: {
      value: (_vm.newPostContent),
      callback: function($$v) {
        _vm.newPostContent = $$v
      },
      expression: "newPostContent"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.submitNewPost($event)
      }
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('button', {
    staticClass: "button minor",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showNewPostForm = false
      }
    }
  }, [_vm._v("Cancel")])], 1)]) : _vm._e(), _vm._v(" "), (Object.keys(_vm.feedPosts || {}).length > 0) ? _vm._l((_vm.feedPosts), function(feedPost) {
    return _c('feed-status-post', {
      key: feedPost.id,
      attrs: {
        "data": feedPost
      }
    })
  }) : _vm._e()], 2)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "load-more-button-container"
  }, [(_vm.fetchingStatus === 'fetched' && Object.keys(_vm.feedPosts || {}).length > 0 && !_vm.hasFetchedAll) ? _c('button', {
    attrs: {
      "id": "feed-fetch-more"
    },
    on: {
      "click": _vm.fetchMore
    }
  }, [_vm._v("Load more posts")]) : _vm._e()])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5090195e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Pages/Game/SubPages/GameFeed.vue
// module id = 869
// module chunks = 2